import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './Routes/AppRouter';  // Import de AppRouter
import { Provider } from 'react-redux';  // Import de Provider de react-redux
import store from './Redux/Store';  // Import de ton store Redux

const root = ReactDOM.createRoot(document.getElementById('root'));
// src/index.js


root.render(
  <React.StrictMode>
    <Provider store={store}> {/* Envelopper ton application avec le Provider */}
      <AppRouter />
    </Provider>
  </React.StrictMode>
);
